import { useEffect } from 'react';
import PropTypes from 'prop-types';

const GlobalBeforeUnloadListener = ({ isChanged }) => {

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (isChanged) {
                event.preventDefault();
                event.returnValue = '';
            }
        };

        const handleNavigation = (event) => {
            if (isChanged) {
                const confirmationMessage = 'Changes you made may not be saved.';
                if (!window.confirm(confirmationMessage)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        };

        const handlePopState = (event) => {
            if (isChanged) {
                const confirmationMessage = 'Changes you made may not be saved.';
                if (!window.confirm(confirmationMessage)) {
                    window.history.pushState(null, '', window.location.href);
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('popstate', handlePopState);

        const addNavigationListeners = () => {
            const buttons = document.getElementsByClassName('nav--primary__item');
            Array.from(buttons).forEach(btn => {
                btn.addEventListener('click', handleNavigation);
            });

            const breadcrumbs = document.getElementsByClassName('breadcrumbs__item');
            Array.from(breadcrumbs).forEach(btn => {
                btn.addEventListener('click', handleNavigation);
            });

            const cancel = document.getElementsByClassName('cancel');
            Array.from(cancel).forEach(btn => {
                btn.addEventListener('click', handleNavigation);
            });

            document.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', handleNavigation);
            });
        };

        const removeNavigationListeners = () => {
            const buttons = document.getElementsByClassName('nav--primary__item');
            Array.from(buttons).forEach(btn => {
                btn.removeEventListener('click', handleNavigation);
            });

            const breadcrumbs = document.getElementsByClassName('breadcrumbs__item');
            Array.from(breadcrumbs).forEach(btn => {
                btn.removeEventListener('click', handleNavigation);
            });

            const cancel = document.getElementsByClassName('cancel');
            Array.from(cancel).forEach(btn => {
                btn.removeEventListener('click', handleNavigation);
            });

            document.querySelectorAll('a').forEach(link => {
                link.removeEventListener('click', handleNavigation);
            });
        };

        if (isChanged) {
            window.history.pushState(null, '', window.location.href);
            addNavigationListeners();
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('popstate', handlePopState);
            removeNavigationListeners();
        };
    }, [isChanged]);

    return null;
};

GlobalBeforeUnloadListener.propTypes = {
    isChanged: PropTypes.bool,
};

export default GlobalBeforeUnloadListener;
